import {createTheme} from '@mui/material/styles';

const DATA_TABLE_THEME = () => createTheme({
  components: {
    MUIDataTableBodyCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
          paddingTop: "10px",
          paddingBottom: "10px",
        }
      }
    },
    MUIDataTableToolbar: {
      styleOverrides: {
        root: {
          width: "100%",
          borderBottom: "1px solid #e2e8f0",
        },
        titleText: {
          fontWeight: 700,
          color: "#0f172a"
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          padding: "10px 12px",
          marginTop: "8px",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: "#334155",
          backgroundColor: "#f8fafc",
        },
        body: {
          padding: "8px 16px"
        }
      }
    }
  }
});

export default DATA_TABLE_THEME;
